document.addEventListener("DOMContentLoaded", () => {
  const faqItems = document.querySelectorAll(".custom-faq--faq-item");

  faqItems.forEach((item) => {
    const faqQuestion = item.querySelector(".faq-item__question");
    const faqAnswer = item.querySelector(".faq-item__answer");

    if (item.classList.contains("active")) {
      faqAnswer.style.height = faqAnswer.scrollHeight + "px";
      faqAnswer.style.opacity = "1";
    }

    faqQuestion.addEventListener("click", () => {
      const isActive = item.classList.toggle("active");

      if (isActive) {
        faqAnswer.style.height = faqAnswer.scrollHeight + "px";
        faqAnswer.style.opacity = "1";
      } else {
        faqAnswer.style.height = "0px";
        faqAnswer.style.opacity = "0";
      }
    });
  });
});
